/** MUI's print export clones the grid at the window's pixel column widths; this fits the clone to the paper. */
export const GRID_PRINT_PAGE_STYLE = `
.MuiDataGrid-root { --DataGrid-rowWidth: 100% !important; }
.MuiDataGrid-virtualScrollerContent > [role="presentation"] { width: 100% !important; }

/* Shrinking stops at 100px: below that, text wraps a letter per line (a 27-column order list prints
   28px columns over hundreds of pages). A grid still wider than the paper then overflows it as before. */
.MuiDataGrid-columnHeader, .MuiDataGrid-cell { flex: 0 1 auto !important; min-width: 100px !important; }
.MuiDataGrid-columnHeaderCheckbox, .MuiDataGrid-cellCheckbox, .MuiDataGrid-cellEmpty {
  flex-shrink: 0 !important;
  min-width: 0 !important;
}
.MuiDataGrid-columnHeader--pinnedLeft, .MuiDataGrid-columnHeader--pinnedRight,
.MuiDataGrid-cell--pinnedLeft, .MuiDataGrid-cell--pinnedRight {
  position: relative !important;
  left: auto !important;
  right: auto !important;
}

.MuiDataGrid-columnHeaders > [role="row"], .MuiDataGrid-columnHeader { height: auto !important; }
.MuiDataGrid-columnHeader { min-height: var(--DataGrid-headerHeight) !important; }
.MuiDataGrid-columnHeaderTitle { white-space: normal !important; overflow-wrap: break-word !important; }
.MuiDataGrid-row { max-height: none !important; }
.MuiDataGrid-cell {
  height: auto !important;
  min-height: var(--height) !important;
  line-height: 1.4 !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
.MuiDataGrid-cell:not(.MuiDataGrid-cell--flex) { padding-top: 8px !important; padding-bottom: 8px !important; }

/* The app keeps the row-actions column visible, so MUI's own print cannot drop it. */
.MuiDataGrid-columnHeader[data-field="actions"], .MuiDataGrid-cell[data-field="actions"] { display: none !important; }
`;
